import addWeeks from 'date-fns/addWeeks';
import startOfDay from 'date-fns/startOfDay';
import startOfWeek from 'date-fns/startOfWeek';
import subWeeks from 'date-fns/subWeeks';
import type { DateRange } from '../types';

export const isDateRangeSame = (dateRange1: DateRange, dateRange2: DateRange): boolean =>
	dateRange1.startDateInclusive.getTime() === dateRange2.startDateInclusive.getTime() &&
	dateRange1.endDateExclusive.getTime() === dateRange2.endDateExclusive.getTime();

export const pickDateRange = (obj: DateRange): DateRange => ({
	startDateInclusive: obj.startDateInclusive,
	endDateExclusive: obj.endDateExclusive,
});

// This function is made to mock easily in examples and tests.
export const getCurrentDate = () => new Date();

export const calculateDateRangeFor12Weeks = (date: Date): DateRange => {
	const thisWeekStart = startOfDay(startOfWeek(date, { weekStartsOn: 1 }));
	const elevenWeeksAgo = startOfDay(subWeeks(thisWeekStart, 11));
	return {
		startDateInclusive: elevenWeeksAgo,
		endDateExclusive: addWeeks(elevenWeeksAgo, 12),
	};
};

export const getWeekRangeFromWeekStartDate = (weekStartDate: Date): DateRange => ({
	startDateInclusive: weekStartDate,
	endDateExclusive: addWeeks(weekStartDate, 1),
});
